export enum ThemeNames {
	codan = 'Codan-theme',
	almbrand = 'Almbrand-theme',
	psk = 'Privatsikring-theme',
}
